const AchievmentConfig = [
  {
    platform: "CodeChef",
    rating: 1779,
    badge: "3 Star Coder",
    image: "https://cdn.codechef.com/images/cc-logo.svg", 
  },
  {
    platform: "LeetCode",
    rating: 2025,
    badge: "Knight",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/LeetCode_Logo_black_with_text.svg/916px-LeetCode_Logo_black_with_text.svg.png", 
  },
  {
    platform: "Codeforces",
    rating: 1324,
    badge: "Pupil",
    image: "https://codeforces.org/s/29330/images/codeforces-sponsored-by-ton.png", 
  }, 
  {
    platform: "GeeksforGeeks",
    rating: "498th Rank in Pict",
    badge: "Gold",
    image: "https://media.geeksforgeeks.org/gfg-gg-logo.svg", 
  },
];

export default AchievmentConfig;
